import { createCustomEnum } from "./customEnum";

export const AuroraOutcomeStatusInProgress = {
	name: "in_progress",
	value: 3,
	displayName: "In Progress",
};

const AuroraOutcomeStatuses = createCustomEnum({
	pass: {
		name: "pass",
		value: 0,
		displayName: "Pass",
	},
	pending_review: {
		name: "pending_review",
		value: 1,
		displayName: "Pending Review",
	},
	fail: {
		name: "fail",
		value: 2,
		displayName: "Fail",
	},
});

export default AuroraOutcomeStatuses;
